import { Cartesian3 } from "cesium";

export class PointsUtils {
  /**
   * Calculate the centroid of a set of points.
   * @param points - The points to calculate the centroid for.
   * @returns The centroid.
   */
  static getCentroid(points: Cartesian3[]): Cartesian3 {
    const sumX = points.map((p) => p.x).reduce((curr, a) => curr + a, 0);
    const sumY = points.map((p) => p.y).reduce((curr, a) => curr + a, 0);
    const sumZ = points.map((p) => p.z).reduce((curr, a) => curr + a, 0);
    return new Cartesian3(
      sumX / points.length,
      sumY / points.length,
      sumZ / points.length,
    );
  }
}
